import React from 'react';
import { ScrollView, FlatList, View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import DuringRoutineCardPlaceholder from '../../components/Routines/ShimmerPlaceholderCards/DuringRoutineCardPlaceholder';
import ShimmerPlaceHolder from '../../libraries/ReactNativeShimmerPlaceholder';
import colors from '../../theme/Colors';
import { getScreenWidth } from '../../utils/LayoutUtility';
import size from '../../theme/Fonts';
import { isIOS } from '../../utils/BooleanUtility';


const shimmerColors = ['#fafafa', '#eeeeee', '#fafafa'];

export const RoutineActivityShimmer = () => {
  return (
    <View>
      <View style={styles.routineActivityContainer}>
        <View style={styles.routineItemContainer}>
          <DuringRoutineCardPlaceholder />
        </View>
        <View style={styles.timelineContainer}>
          <ShimmerPlaceHolder colorShimmer={shimmerColors} autoRun style={styles.timelineTextPlaceholder} />
          <View style={styles.verticalLine} />
        </View>
      </View>
      <View style={styles.routineActivityContainer}>
        <View style={styles.routineItemContainer}>
          <DuringRoutineCardPlaceholder />
        </View>
        <View style={styles.timelineContainer}>
          <ShimmerPlaceHolder colorShimmer={shimmerColors} autoRun style={styles.timelineTextPlaceholder} />
        </View>
      </View>
    </View>
  );
};

const RoutineScreenPlaceHolder = () => {
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <ShimmerPlaceHolder colorShimmer={shimmerColors} autoRun style={styles.placeholderTitle} />
      <FlatList
        data={new Array(5)}
        horizontal
        keyExtractor={(item) => `${item}`}
        renderItem={() => (
          <ShimmerPlaceHolder colorShimmer={shimmerColors} autoRun style={styles.placeholderListItem} />
        )}
        showsHorizontalScrollIndicator={false}
        bounces={false}
      />
      <RoutineActivityShimmer />
    </ScrollView>
  );
};

export default RoutineScreenPlaceHolder;

const { ids, styles } = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    width: getScreenWidth(),
    alignSelf: 'center',
  },
  headerContainerWeb: {
    padding: 12,
    paddingRight: 0,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 10,
  },
  activityContainer: {
    paddingLeft: 12,
    justifyContent: 'flex-end',
    width: '100%',
  },
  cardContainer: {
    width: getScreenWidth() - 58,
    alignSelf: 'flex-end',
    paddingHorizontal: 12,
    paddingVertical: 12,
  },
  gradient: {
    borderRadius: 16,
  },
  actionButtonContainer: {
    height: 40,
    width: '100%',
    alignSelf: 'center',
    backgroundColor: 'transparent',
    marginTop: 12,
  },
  actionButton: {
    left: 12,
    right: 12,
    bottom: 14,
    height: 40,
    borderRadius: 8,
  },
  actionButtonText: {
    color: colors.white,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
  },
  actionButtonIcon: {
    width: 18,
    height: 18,
    tintColor: colors.white,
    resizeMode: 'contain',
    marginRight: 4,
  },
  headerContainer: {
    padding: 12,
    paddingRight: 0,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: isIOS() ? 56 : 46,
  },
  headerTitle: {
    color: colors.foxyBlack,
    fontSize: size.h3,
    fontFamily: 'Roboto-Medium',
    flex: 1,
  },
  headerIcon: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
  },
  headerIconContainer: {
    height: 32,
    width: 32,
    borderRadius: 16,
    backgroundColor: colors.white,
    marginRight: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  activityCardHeaderContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    paddingTop: 12,
    paddingHorizontal: 12,
  },
  activityCardTitleContainer: {
    flex: 1,
  },
  activityCardTitle: {
    color: colors.black,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h1,
  },
  activityCardHeaderIcon: {
    width: 32,
    height: 32,
    marginRight: 12,
    resizeMode: 'contain',
  },
  subtitle: {
    color: colors.foxyBlack,
    fontSize: size.h4,
    fontFamily: 'Roboto-Regular',
    marginTop: 4,
  },
  point: {
    color: colors.subtitle,
    width: 4,
    height: 4,
  },
  playIcon: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
  },
  divider: {
    backgroundColor: colors.white,
    height: 1,
    marginVertical: 12,
    marginHorizontal: 12,
  },
  routineItemContainer: {
    marginLeft: 52,
    marginRight: 12,
  },
  verticalLine: {
    width: 1,
    flex: 1,
    backgroundColor: colors.divider,
  },
  verticalLineGreen: {
    width: 1,
    backgroundColor: colors.green,
    zIndex: 1,
    top: 0,
    position: 'absolute',
  },
  timelineText: {
    color: colors.black,
    fontFamily: 'Roboto-Regular',
    fontSize: size.h3_5,
    marginBottom: 4,
    backgroundColor: colors.background,
  },
  timelineTextPlaceholder: {
    height: 16,
    width: 32,
    borderRadius: 8,
  },
  timelineContainer: {
    position: 'absolute',
    top: 0,
    left: 8,
    height: '100%',
    width: 58,

    alignItems: 'center',
  },
  routineActivityContainer: {
    marginBottom: 22,
    marginTop: 4,
  },
  placeholderTitle: {
    width: 100,
    height: 20,
    alignSelf: 'center',
    borderRadius: 4,
  },
  placeholderListItem: {
    height: 60,
    width: 37,
    marginVertical: 20,
    marginHorizontal: 12,
    borderRadius: 20,
  },
  toast: {
    position: 'absolute',
    bottom: 0,
    maxWidth: getScreenWidth() - 32,
  },
  dashedBorder: {
    alignSelf: 'center',
    width: '60%',
    height: 1,
    borderWidth: 1,
    borderRadius: 2,
    borderColor: colors.foxyBlack,
    borderStyle: 'dashed',
  },
});
